import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';

import { library, config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';

import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';

import ImageHandler from '../../utils/ImageHandler';
import SEO from '../SEO/SEO';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Video from '../../utils/Vimeo';

import SlashBlack from '../../../static/images/slash-black-top.svg';
import SlashBlue from '../../../static/images/slash-blue-top.svg';
import SlashRed from '../../../static/images/slash-red-top.svg';
import SlashGreen from '../../../static/images/slash-green-top.svg';
import SlashPink from '../../../static/images/slash-pink-top.svg';
import SlashYellow from '../../../static/images/slash-yellow-top.svg';
import SlashBlackBottom from '../../../static/images/slash-black-bottom.svg';
import SlashBlueBottom from '../../../static/images/slash-blue-bottom.svg';
import SlashRedBottom from '../../../static/images/slash-red-bottom.svg';
import SlashGreenBottom from '../../../static/images/slash-green-bottom.svg';
import SlashPinkBottom from '../../../static/images/slash-pink-bottom.svg';
import SlashYellowBottom from '../../../static/images/slash-yellow-bottom.svg';

config.autoAddCss = false;
library.add(fab, fas);

const ColorSwitcher = (colour) => {
  switch (colour) {
    case 'black':
      return { top: SlashBlack, bottom: SlashBlackBottom };
    case 'red':
      return { top: SlashRed, bottom: SlashRedBottom };
    case 'yellow':
      return { top: SlashYellow, bottom: SlashYellowBottom };
    case 'green':
      return { top: SlashGreen, bottom: SlashGreenBottom };
    case 'pink':
      return { top: SlashPink, bottom: SlashPinkBottom };
    case 'blue':
      return { top: SlashBlue, bottom: SlashBlueBottom };
    default:
      return { top: SlashBlack, bottom: SlashBlackBottom };
  }
};

// ====

const Layout = (props) => {
  const {
    children,
    meta,
    settings,
    mode,
    openGraph,
    image,
    background,
    size,
    video,
    pauseVideo,
  } = props;

  let siteSettings = null;

  if (mode === 'editor') {
    siteSettings = settings;
  } else {
    const siteData = useStaticQuery(graphql`
      {
        storyblokEntry(slug: { eq: "layout" }) {
          content
        }
      }
    `);

    siteSettings = JSON.parse(siteData.storyblokEntry.content);
  }
  return (
    <>
      <SEO
        meta={meta}
        settings={siteSettings}
        openGraph={openGraph}
        mode="helmet"
      />
      <div
        className={`brand-page-background brand-background-cover brand-background-${
          !video ? background : 'transparent'
        } ${size && `brand-page-background-${size}`}`}
        style={{
          backgroundImage: `url(${!video && ImageHandler(image, '1920x1080')})`,
        }}
      >
        {video && pauseVideo === false && (
          <div className="brand-body-video">
            <Video
              source={video}
              autoPlay
              controls={false}
              background
              loop
              poster={ImageHandler(image, '1920x1080')}
            />
          </div>
        )}
        <div className="brand-page-background-fade" />
        <img
          src={ColorSwitcher(background).top}
          className="brand-slash brand-slash-top"
          alt=""
        />
        {!video && (
          <img
            src={ColorSwitcher(background).bottom}
            className="brand-slash brand-slash-bottom"
            alt=""
          />
        )}
      </div>
      <div className="brand-page">
        <Header mode={mode} settings={siteSettings} background={background} />
        {children}
        <Footer mode={mode} settings={siteSettings} />
      </div>
    </>
  );
};

export default Layout;

// ====

Layout.propTypes = {
  settings: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  meta: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mode: PropTypes.string,
  size: PropTypes.string,
  video: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

Layout.defaultProps = {
  settings: null,
  meta: null,
  mode: 'normal',
  size: 'regular',
  video: false,
};

/*
                <iframe
                  src="//player.vimeo.com/video/451483635?background=1"
                  width="100%"
                  height="100%"
                  frameborder="0"
                  allow="autoplay; fullscreen"
                  allowfullscreen
                ></iframe>
                */
